import { Status } from '../status';
import {Column} from '../column';

export class KanbanColumn extends Column {
  public current: number;
  public max: number;

  constructor(name: string, statuses: Status[], max: number) {
    super(name, statuses);
    this.max = max;
  }

  setNumIssues(numberOfIssues: number): void {
    this.current = numberOfIssues;
  }
}
